import usePresentPage, { selectors } from 'client/hooks/usePresentPage'
import { useWebsiteSettings } from 'client/store'
import { PageTypeEnum } from 'common/enums/PageTypeEnum'
import { websitePagesQuery } from 'src/editor/api/queries/website-pages-query'
import {
  getWebsiteDomain,
  getWebsiteId,
} from 'src/editor/store/website-settings/website-settings-selector'

export const useWebsiteHomePageUrl = () => {
  const websiteId = useWebsiteSettings(getWebsiteId) as number
  const websiteDomain = useWebsiteSettings(getWebsiteDomain)
  const { data } = websitePagesQuery.useQuery({
    queryFnArgs: [websiteId],
  })
  const currentLocale = usePresentPage(selectors.getPageLocale)
  const homepagePath =
    data?.pages
      .find(page => page.pageType === PageTypeEnum.WebsiteHome)
      ?.locales.find(locale => locale.locale === currentLocale)?.path ?? ''
  const homepageUrl = `https://${websiteDomain?.name}/${homepagePath}`

  return {
    homepageUrl,
  }
}
